import React, { useState } from "react";
import {
    AppBar,
    Toolbar,
    Button,
    Container,
    IconButton,
    Drawer,
    List,
    ListItem,
    ListItemText,
    Hidden,
} from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import { Link, useLocation } from "react-router-dom";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import useQueryString from "../../hooks/useQueryString";
import { getQueryStringValue } from "../../utils/queryString";




const useStyles = makeStyles((theme: Theme) =>
        createStyles({
                    Active: {
                        color: "rgb(7, 184, 248) !important",

                    },
                },
        ));
const Header: React.FC = () => {
    const [drawerOpen, setDrawerOpen] = useState(false);
    const location = useLocation();
    const urlToken = getQueryStringValue("token");
    const [token, setToken] = useQueryString("token", urlToken);
    const classes = useStyles();
    const toggleDrawer = (open: boolean) => () => {
        setDrawerOpen(open);
    };

    const navItems = [
        { label: "Home", path: "/iul" },
        { label: "Tax Efficiency", path: "/iul/tax-efficiency" },
        { label: "Safety Features", path: "/iul/safety-features" },
        { label: "Participating Policy Loans", path: "/iul/participating" },
        { label: "Estimate Benefits", path: "/iul/estimate-benefits" },
        { label: "Turbocharge Your IUL", path: "/iul/turbocharge-iul" },
        { label: "Start Enrollment", path: `/accept/invitation/${token}`},
    ];

    // console.log("token", token);

    return (
            <AppBar position="sticky" color="inherit" elevation={0}>
                <Container maxWidth="xl">
                    <Toolbar style={{ justifyContent: "center" }}>
                        {/* Desktop Menu */}
                        <Hidden smDown>
                            <div>
                                {navItems.map((item) => (
                                        <Button
                                                // Conditionally change color for active desktop button
                                                className={location.pathname === item.path ? classes.Active : " "}
                                                key={item.label}
                                                color="primary"
                                                style={{ margin: "0 8px" }}
                                                component={Link}
                                                to={`${item.path + `?token=${token}`}`}
                                        >
                                            <strong className="f18">{item.label}</strong>
                                        </Button>
                                ))}
                            </div>
                        </Hidden>

                        {/* Mobile Menu Icon */}
                        <Hidden mdUp>
                            <IconButton edge="end" color="inherit" onClick={toggleDrawer(true)}>
                                <MenuIcon />
                            </IconButton>
                        </Hidden>
                    </Toolbar>
                </Container>

                {/* Mobile Drawer */}
                <Drawer anchor="right" open={drawerOpen} onClose={toggleDrawer(false)}>
                    <List style={{ width: 250 }}>
                        {navItems.map((item) => (
                                <ListItem
                                        button
                                        key={item.label}
                                        component={Link}
                                        to={`${item.path + `?token=${token}`}`}
                                        onClick={toggleDrawer(false)}
                                >
                                    <ListItemText primary={item.label} />
                                </ListItem>
                        ))}
                    </List>
                </Drawer>
            </AppBar>
    );
};

export default Header;
